var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgFooterPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.659 8.29271C19.7961 8.18776 20 8.28594 20 8.45182V15.375C20 16.2721 19.2441 17 18.3125 17H3.6875C2.75586 17 2 16.2721 2 15.375V8.45521C2 8.28594 2.20039 8.19115 2.34102 8.29609C3.12852 8.88516 4.17266 9.63333 7.75859 12.1419C8.50039 12.6633 9.75195 13.7602 11 13.7534C12.2551 13.7635 13.5312 12.643 14.2449 12.1419C17.8309 9.63333 18.8715 8.88177 19.659 8.29271ZM11 12.6667C11.8156 12.6802 12.9898 11.6781 13.5805 11.2651C18.2457 8.00495 18.6008 7.72057 19.6766 6.90807C19.8805 6.75573 20 6.51875 20 6.26823V5.625C20 4.72786 19.2441 4 18.3125 4H3.6875C2.75586 4 2 4.72786 2 5.625V6.26823C2 6.51875 2.11953 6.75234 2.32344 6.90807C3.39922 7.71719 3.7543 8.00495 8.41953 11.2651C9.01016 11.6781 10.1844 12.6802 11 12.6667Z",
    fill: "#0562FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgFooterPhone);
export default __webpack_public_path__ + "static/media/SvgFooterPhone.ac01a104ed0536c119dd49bf0819b038.svg";
export { ForwardRef as ReactComponent };